import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Student from "@/pages/Student";
import Parent from "@/pages/Parent";
import PropertyManager from "@/pages/PropertyManager";
import FAQ from "@/pages/FAQ";
import Waitlist from "@/pages/Waitlist";
import PrivacyTerms from "@/pages/PrivacyTerms";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/student" element={<Student />} />
          <Route path="/parent" element={<Parent />} />
          <Route path="/property-manager" element={<PropertyManager />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/privacy-terms" element={<PrivacyTerms />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
